module.exports = __webpack_public_path__ + "static/media/icomoon.9902d9e6.ttf";